/* eslint-disable no-template-curly-in-string */
import type { monaco } from 'react-monaco-editor';

const builtinConstants = 'True|False|None';

const builtinFunctions =
  'abs|all|enumerate|int|str|any|' +
  'pow|sum|print|' +
  'tuple|bool|len|range|type|' +
  'float|list|format|reduce|' +
  'long|getattr|repr|' +
  'max|reversed|zip|hasattr|' +
  'hash|min|set|' +
  'dict|dir|sorted';

const keywords = 'and|break|continue|def|elif|else|for|if|in|lambda|not|or|pass|return';

const registerCompletions = (monacoInstance: typeof monaco) => {
  const registration = monacoInstance.languages.registerCompletionItemProvider('python', {
    triggerCharacters: ['.'],
    provideCompletionItems(model, position) {
      const lineContent = model.getLineContent(position.lineNumber);
      const lastWordBeforeCursor = lineContent.substring(0, position.column).split(' ').pop();

      // Check if the word before the cursor contains 'json.' and only show json functions
      if (lastWordBeforeCursor?.startsWith('json.')) {
        return {
          suggestions: [
            {
              label: 'decode',
              detail: 'function',
              documentation: 'Decode a JSON string',
              kind: monacoInstance.languages.CompletionItemKind.Function,
              insertTextRules:
                monacoInstance.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              insertText: 'decode(${1})',
            },
            {
              label: 'encode',
              detail: 'function',
              documentation: 'Encode a JSON string',
              kind: monacoInstance.languages.CompletionItemKind.Function,
              insertTextRules:
                monacoInstance.languages.CompletionItemInsertTextRule.InsertAsSnippet,
              insertText: 'encode(${1})',
            },
          ] as monaco.languages.CompletionItem[],
        };
      }

      return {
        suggestions: [
          ...builtinConstants.split('|').map(constant => ({
            label: constant,
            detail: 'constant',
            kind: monacoInstance.languages.CompletionItemKind.Constant,
            insertText: constant,
          })),
          ...keywords.split('|').map(keyword => ({
            label: keyword,
            detail: 'keyword',
            kind: monacoInstance.languages.CompletionItemKind.Keyword,
            insertText: keyword,
          })),
          ...builtinFunctions.split('|').map(func => ({
            label: func,
            detail: 'function',
            kind: monacoInstance.languages.CompletionItemKind.Function,
            insertText: `${func}()`,
          })),
          {
            label: 'Parse Log',
            detail: 'function',
            kind: monacoInstance.languages.CompletionItemKind.Function,
            insertText: 'def parse(log):\n    ',
            range: {
              startLineNumber: position.lineNumber,
              startColumn: 1, // Start from the first character of the line
              endLineNumber: position.lineNumber,
              endColumn: position.column + 1, // End at the end of the line
            },
            commitCharacters: [' '], // Optionally specify which characters commit the completion
          },
          {
            label: 'json',
            detail: 'module',
            documentation: 'JSON functions',
            kind: monacoInstance.languages.CompletionItemKind.Function,
            insertText: 'json',
          },
        ] as monaco.languages.CompletionItem[],
      };
    },
  });

  return registration;
};

export default registerCompletions;
